exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".usersAdd{background:#efecec}.user-add{margin-top:40px}.floating-panel{-webkit-box-shadow:-4px 5px 6px -3px rgba(0,0,0,.16);box-shadow:-4px 5px 6px -3px rgba(0,0,0,.16);border-radius:3px;background:#fff}", ""]);

// exports
